
import { trackMeta, trackMetaCustom } from "../../utils/metaPixel";
import { trackEvent } from "../../utils/googleAnalytics";
import {
  CREATE_ADDRESS_ERROR,
  CREATE_ADDRESS_REQUEST,
  CREATE_ADDRESS_REQUEST_FAIL,
  CREATE_ADDRESS_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_REQUEST_FAIL,
  FORGOT_PASSWORD_SUCCESS,
  GET_USER_LOCATION,
  LIST_ADDRESS_ERROR,
  LIST_ADDRESS_REQUEST,
  LIST_ADDRESS_REQUEST_FAIL,
  LIST_ADDRESS_SUCCESS,
  LOGIN_USER_FAIL,
  LOGIN_USER_REQUEST,
  LOGIN_USER_REQUEST_FAIL,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER_REQUEST,
  LOGOUT_USER_SUCCESS,
  TOKEN_VERIFY_FAIL,
  TOKEN_VERIFY_REQUEST,
  TOKEN_VERIFY_REQUEST_FAIL,
  TOKEN_VERIFY_SUCCESS,
  UPDATE_USER_PASSWORD_ERROR,
  UPDATE_USER_PASSWORD_FAIL,
  UPDATE_USER_PASSWORD_REQUEST,
  UPDATE_USER_PASSWORD_SUCCESS,
  UPDATE_USER_PROFILE_ERROR,
  UPDATE_USER_PROFILE_FAIL,
  UPDATE_USER_PROFILE_REQUEST,
  UPDATE_USER_PROFILE_SUCCESS,
  USER_SIGNUP_FAIL,
  USER_SIGNUP_REQUEST,
  USER_SIGNUP_REQUEST_FAIL,
  USER_SIGNUP_SUCCESS,
} from "../constant/User";
import { ApiURL } from "../../setting/GlobleVariable";
import toast from "react-hot-toast";

// ----- create user
// Where to go after signing in or up: an internal path from ?next=, else home.
export const nextPath = () => {
  try {
    const n = new URLSearchParams(window.location.search).get("next") || "";
    return n.startsWith("/") && !n.startsWith("//") ? n : "/";
  } catch (_) {
    return "/";
  }
};

export const UserSignUp = (formdata, navigate, isLoginModal, setActive, closeModal) => async (dispatch) => {
  try {
    dispatch({ type: USER_SIGNUP_REQUEST });
    const res = await fetch(`${ApiURL}/user/registration`, {
      method: "POST",
      headers: {
        // "Content-Type": "multipart/form-data",
      },
      body: formdata,
    });
    dispatch({ type: USER_SIGNUP_REQUEST_FAIL });
    const data = await res.json();
    if (res.status === 400) {
      return toast.error(data.message, { duration: 5000 });
    }
    if (res.status === 200) {
      dispatch({ type: USER_SIGNUP_SUCCESS });
      trackMeta("CompleteRegistration", { status: true });
      trackEvent("sign_up", { method: "email" });
      if (data.Token) {
        // One account: signing up signs you in.
        localStorage.setItem("instapass_user_token", data.Token);
        dispatch({ type: LOGIN_USER_SUCCESS, payload: { ...data.user, capabilities: data.capabilities } });
        toast.success("Welcome to InstaPass!", { duration: 3000 });
        if (isLoginModal) {
          if (closeModal) closeModal(false);
          else setActive(1);
        } else {
          navigate(nextPath());
        }
        return;
      }
      toast.success(data.message, { duration: 3000 });
      if (isLoginModal) {
        setActive(1)
      } else {
        navigate("/login" + window.location.search);
      }
    }
  } catch (error) {
    dispatch({ type: USER_SIGNUP_FAIL });
  }
};

// ---------------------- user login
export const UserLogin = (email, password, navigate, isModelogin, isSetModel) => async (dispatch) => {
  try {
    dispatch({ type: LOGIN_USER_REQUEST });
    const res = await fetch(`${ApiURL}/user/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: email, password: password }),
    });

    dispatch({ type: LOGIN_USER_REQUEST_FAIL });
    const data = await res.json();
    if (res.status === 400) {
      return toast.error(data.message);
    } else {
      toast.success(data.message);
      dispatch({ type: LOGIN_USER_SUCCESS, payload: { ...data.user, capabilities: data.capabilities } });
      localStorage.setItem("instapass_user_token", data.Token);
      if (isModelogin) {
        isSetModel(false);
      } else {
        navigate(nextPath());
      }
    }
  } catch (error) {
    dispatch({ type: LOGIN_USER_FAIL });
  }
};

// ----- tokrn verify
export const TokenVerify = () => async (dispatch) => {
  try {
    dispatch({ type: TOKEN_VERIFY_REQUEST });

    const res = await fetch(`${ApiURL}/user/verify`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.getItem("instapass_user_token"),
      },
    });
    dispatch({ type: TOKEN_VERIFY_REQUEST_FAIL });
    const data = await res.json();
    if (res.status === 400) {
      if (data?.message === "jwt expired") {
        return "jwt expired"
      }
      return;
    } else {
      dispatch({ type: TOKEN_VERIFY_SUCCESS, payload: { ...data.User, capabilities: data.capabilities } });
    }
  } catch (error) {
    dispatch({ type: TOKEN_VERIFY_FAIL });
  }
};

// ---- logout User
export const LogoutUserFunc = (navigate) => async (dispatch) => {
  dispatch({ type: LOGOUT_USER_REQUEST });
  localStorage.removeItem("instapass_user_token");
  // Also end a Clerk session (Apple / Google / phone sign-in), if there is one.
  try { if (window.Clerk?.session) await window.Clerk.signOut(); } catch (_) {}
  dispatch({ type: LOGOUT_USER_SUCCESS });
  toast.success("Successfully logged out", { duration: 3000 });
  navigate("/");
};

// ============ update user profile
export const UpdateUserProfile = (formdata, navigate) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_USER_PROFILE_REQUEST });
    const res = await fetch(`${ApiURL}/user/update/profile`, {
      method: "POST",
      headers: {
        // "Content-Type": "multipart/form-data",
        token: localStorage.getItem("instapass_user_token"),
      },
      body: formdata,
    });
    dispatch({ type: UPDATE_USER_PROFILE_FAIL });
    const data = await res.json();
    if (res.status === 400) {
      return toast.error(data.message, { duration: 5000 });
    }
    if (res.status === 200) {
      dispatch({ type: UPDATE_USER_PROFILE_SUCCESS });
      trackMetaCustom("ProfileCompleted");
      trackEvent("profile_completed");
      toast.success(data.message, { duration: 3000 });
      // navigate("/login");
    }
  } catch (error) {
    dispatch({ type: UPDATE_USER_PROFILE_ERROR });
  }
};

// ===== update user password
export const UpdateUserPassword =
  (oldPassword, newPassword) => async (dispatch) => {
    try {
      dispatch({ type: UPDATE_USER_PASSWORD_REQUEST });
      const res = await fetch(`${ApiURL}/user/update/password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("instapass_user_token"),
        },
        body: JSON.stringify({ oldPassword, newPassword }),
      });
      dispatch({ type: UPDATE_USER_PASSWORD_FAIL });
      const data = await res.json();
      if (res.status === 400) {
        return toast.error(data.message, { duration: 5000 });
      }
      if (res.status === 200) {
        dispatch({ type: UPDATE_USER_PASSWORD_SUCCESS });
        toast.success(data.message, { duration: 3000 });
        // navigate("/login");
      }
    } catch (error) {
      dispatch({ type: UPDATE_USER_PASSWORD_ERROR });
    }
  };

export const GetUserLocationFunc = (location) => async (dispatch) => {
  dispatch({ type: GET_USER_LOCATION, payload: location });
};

// ---- forgot password
export const ForgotPassword = (email, setIsOTPVerify) => async (dispatch) => {
  try {
    dispatch({ type: FORGOT_PASSWORD_REQUEST });

    const res = await fetch(`${ApiURL}/user/forgot/OTP/send`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: email }),
    });

    dispatch({ type: FORGOT_PASSWORD_REQUEST_FAIL });
    const data = await res.json();
    if (res.status === 400) {
      return toast.error(data.message);
    } else {
      toast.success(data.message);
      setIsOTPVerify(true);
      dispatch({ type: FORGOT_PASSWORD_SUCCESS });
    }
  } catch (error) {
    dispatch({ type: FORGOT_PASSWORD_ERROR });
  }
};

// reset password
export const ResetPassword =
  (OTP, NewPassword, navigate, email) => async (dispatch) => {
    try {
      dispatch({ type: FORGOT_PASSWORD_REQUEST });

      const res = await fetch(`${ApiURL}/user/resetpassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, OTP, NewPassword }),
      });

      dispatch({ type: FORGOT_PASSWORD_REQUEST_FAIL });
      const data = await res.json();
      if (res.status === 400) {
        return toast.error(data.message);
      } else {
        toast.success(data.message);
        navigate("/");
        dispatch({ type: FORGOT_PASSWORD_SUCCESS });
      }
    } catch (error) {
      dispatch({ type: FORGOT_PASSWORD_ERROR });
    }
  };


  // ---- create address
  export const createAddressAction = (formdata ,setHideModal) => async (dispatch) => {
    try {
      dispatch({ type: CREATE_ADDRESS_REQUEST });
      const res = await fetch(`${ApiURL}/address/create`, {
        method: "POST",
        headers: {
        "Content-Type": "application/json",
          token: localStorage.getItem("instapass_user_token"),
        },
        body: JSON.stringify(formdata),
      });
      const data = await res.json();
      if (res.status === 400) {
        dispatch({ type: CREATE_ADDRESS_REQUEST_FAIL });
        return toast.error(data.message, { duration: 5000 });
      }
      if (res.status === 200) {
        dispatch({ type: CREATE_ADDRESS_SUCCESS, payload: data.Address || data.address });
        setHideModal(false);
        dispatch(listAddressAction());
        toast.success(data.message, { duration: 3000 });
      } else {
        dispatch({ type: CREATE_ADDRESS_REQUEST_FAIL });
      }
    } catch (error) {
      dispatch({ type: CREATE_ADDRESS_ERROR });
    }
  };

  // ---------- lis 
  export const listAddressAction = () => async (dispatch) => {
    try {
      dispatch({ type: LIST_ADDRESS_REQUEST });
      const res = await fetch(`${ApiURL}/address/list`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("instapass_user_token"),
        },
      });
      const data = await res.json();
      if (res.status === 400) {
        dispatch({ type: LIST_ADDRESS_REQUEST_FAIL });
        return toast.error(data.message, { duration: 5000 });
      }
      if (res.status === 200) {
        const list = data.Addresses || data.addresses || [];
        dispatch({ type: LIST_ADDRESS_SUCCESS, payload: list });
        return list;
      } else {
        dispatch({ type: LIST_ADDRESS_REQUEST_FAIL });
        return [];
      }
    } catch (error) {
      dispatch({ type: LIST_ADDRESS_ERROR });
      return [];
    }
  };

  export const updateAddressAction = (id, formdata) => async (dispatch) => {
    try {
      dispatch({ type: CREATE_ADDRESS_REQUEST });
      const res = await fetch(`${ApiURL}/address/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("instapass_user_token"),
        },
        body: JSON.stringify(formdata),
      });
      const data = await res.json();
      if (res.status === 400 || res.status === 404) {
        dispatch({ type: CREATE_ADDRESS_REQUEST_FAIL });
        return toast.error(data.message || "Could not update address", { duration: 5000 });
      }
      if (res.status === 200) {
        dispatch({ type: CREATE_ADDRESS_SUCCESS, payload: data.Address });
        dispatch(listAddressAction());
        toast.success(data.message || "Address updated", { duration: 3000 });
      }
    } catch (error) {
      dispatch({ type: CREATE_ADDRESS_ERROR });
    }
  };

  // ---- get user dashboard statistics
  export const GetUserStats = () => async (dispatch) => {
    try {
      const res = await fetch(`${ApiURL}/user/stats`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("instapass_user_token"),
        },
      });
      
      const data = await res.json();
      
      if (res.status === 200) {
        return {
          success: true,
          stats: data.stats
        };
      } else {
        console.error("Get user stats error:", data.message);
        return {
          success: false,
          error: data.message
        };
      }
    } catch (error) {
      console.error("Get user stats error:", error);
      return {
        success: false,
        error: error.message
      };
    }
  };

  // ---- update user profile (new dashboard version)
  export const UpdateUserProfileDashboard = (profileData) => async (dispatch) => {
    try {
      dispatch({ type: UPDATE_USER_PROFILE_REQUEST });
      
      const formData = new FormData();
      
      // Add profile fields to FormData
      Object.keys(profileData).forEach(key => {
        if (key === 'socialMedia') {
          formData.append(key, JSON.stringify(profileData[key]));
        } else if (profileData[key] !== undefined && profileData[key] !== null) {
          formData.append(key, profileData[key]);
        }
      });

      const res = await fetch(`${ApiURL}/user/profile`, {
        method: "PUT",
        headers: {
          token: localStorage.getItem("instapass_user_token"),
        },
        body: formData,
      });
      
      dispatch({ type: UPDATE_USER_PROFILE_FAIL });
      const data = await res.json();
      
      if (res.status === 400) {
        return toast.error(data.message, { duration: 5000 });
      }
      
      if (res.status === 200) {
        dispatch({ type: UPDATE_USER_PROFILE_SUCCESS, payload: data.user });
        trackMetaCustom("ProfileCompleted");
        trackEvent("profile_completed");
        toast.success(data.message, { duration: 3000 });
        return {
          success: true,
          user: data.user
        };
      }
    } catch (error) {
      dispatch({ type: UPDATE_USER_PROFILE_ERROR });
      toast.error("Profile update failed", { duration: 5000 });
      return {
        success: false,
        error: error.message
      };
    }
  };